import api from "../../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY

export const getPurchaseOrderDetails = async (folio) => {
    try {
        const response = await api.get(`${urlApi}/administracion/gasoline/getPurchaseOrderDetails/${folio}`);
        return response.data;
    } catch (e) {
        throw new Error(e);
    }
}